import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export var Menu = function Menu(_ref) {
  var innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "refinement-bar.common.ui.select.menu",
    ref: innerRef
  }, innerProps), children);
};